import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

import dataUtils from '../../util/DataUtils';

import styles from './styles';

class VideoFrame extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.nextVideo = this.nextVideo.bind(this);

        this.playerRef = React.createRef();

        this.state = {
            videoIndex: 0
        };
    }

    componentDidUpdate() {
        if (dataUtils.filterArchivedVideos(this.props.videos).length) {
            const internalPlayer = this.playerRef.current.getInternalPlayer();
            if (internalPlayer && internalPlayer.hasOwnProperty('playVideo') && !this.playerRef.current.player.isPlaying) {
                internalPlayer.playVideo();
            }
        }
    }

    nextVideo() {
        this.setState({videoIndex: (this.state.videoIndex + 1) % dataUtils.filterArchivedVideos(this.props.videos).length});
    }

    render() {
        const filteredVideos = dataUtils.filterArchivedVideos(this.props.videos);
        if (!filteredVideos.length) return <div/>;

        return (
            <ReactPlayer
                className="video-wrapper"
                loop={true}
                muted={true}
                onEnded={this.nextVideo}
                playing={true}
                url={filteredVideos[this.state.videoIndex].url}
                ref={this.playerRef}
                {...styles.videoFrame()}
            />
        );

    }
}

VideoFrame.propTypes = {
    videos: PropTypes.object
};

export default VideoFrame;


// WEBPACK FOOTER //
// ./src/components/common/VideoFrame.js